export default __webpack_public_path__ + "static/media/nature_gift.323c4e52.png";